import { useQuery } from '@tanstack/react-query'
import { listCurrencies, type Currency } from '../../../types'
import { actionApiCall } from '../api/actionApiCall'

/** Číselník měn se mění jen při nasazení, proto se drží dlouho v cache. */
export function useCurrencies() {
    return useQuery({
        queryKey: ['currencies'],
        // Nepřihlášený návštěvník veřejného náhledu číselník nedostane - chybu
        // není proč zobrazovat, formátování si poradí s výchozími hodnotami.
        queryFn: () => actionApiCall(() => listCurrencies(), { silent: true }),
        staleTime: 24 * 60 * 60 * 1000,
    })
}

export function findCurrency(currencies: Currency[] | undefined, code: string): Currency | undefined {
    return currencies?.find((currency) => currency.code === code)
}
